<template lang="html">
<el-container>
<el-header class="main-body-search">
      <el-form :inline="true" :model="filters">
          <el-form-item>
            <el-select v-model="filters.appId" filterable placeholder="请选择">
              <el-option  v-for="item in appList"  :key="item.id" :label="item.appName" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-input v-model="filters.roleName" placeholder="角色名称" @keyup.enter.native="getRoleMutexAprvList"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="getRoleMutexAprvList">查询</el-button>
          </el-form-item>
        </el-form>
</el-header>
 <el-main class="main-body-table">
     <!--列表-->
    <el-table :data="tableGridData" style="width: 100%">
          <el-table-column  type="index"  fixed  width="60"></el-table-column>
          <el-table-column  prop="roleName" label="角色" width="100"></el-table-column>
          <el-table-column  prop="detail" label="角色描述" width="250"></el-table-column>
          <el-table-column  prop="mutexRoleNames"  label="互斥角色"  width="300"></el-table-column>
          <el-table-column  prop="action" label="操作" width="100">
             <template slot-scope="scope">
                <el-tag
                  v-if="scope.row.action === 1"
                  :type="scope.row.action === 2 ? 'danger' : 'success'"
                  close-transition>
                  增加
                </el-tag>
                <el-tag
                  v-if="scope.row.action === 2"
                  :type="scope.row.action === 2 ? 'danger' : 'success'"
                  close-transition>
                  删除
                </el-tag>
                <el-tag
                  v-if="scope.row.action === 3"
                  close-transition>
                  更新
                </el-tag>
            </template>
          </el-table-column>
          <el-table-column  prop="appName" label="所属应用" width="150"></el-table-column>
          <el-table-column label="操作" width="250" fixed="right">
            <template slot-scope="scope">
              <div>
                <el-button size="small" type="success" @click="approve(scope.$index, scope.row)">通过</el-button>
                <el-button type="danger" size="small" @click="reject(scope.$index, scope.row)">拒绝</el-button>
              </div>
            </template>
          </el-table-column>
    </el-table>
    <!--工具条-->
    <el-pagination class="main-body-table-page" layout="total, prev, pager, next, jumper" @current-change="handleCurrentChange" :current-page="page.current" :page-size="page.size" :total="page.total">
    </el-pagination>
   </el-main>
</el-container>
</template>

<script>
export default {
  data() {
    return {
      appList: [], // 应用列表
      roleTableData: [],
      filters: {
        appId: '',
        roleName: ''
      },
      page: {
        current: 1, // 当前页
        size: 10, // 每页个数
        total: 0 // 默认数据总数
      },
      tableGridData: []
    }
  },
  mounted() {
    this.initAppSelectList()
    this.getRoleMutexAprvList()
  },
  methods: {
    initAppSelectList() {
      this.$http
        .post('/sum/sumApp/selectList')
        .then(res => {
          let { code, data } = res
          if (code === 20000) {
            this.appList = data
          }
        })
        .catch(rej => {
          console.log(rej)
        })
    },
    // 翻页
    handleCurrentChange(val) {
      this.page.current = val
      this.getRoleMutexAprvList()
    },
    // 查询角色互斥信息
    getRoleMutexAprvList() {
      this.filters.current = this.page.current
      this.filters.size = this.page.size
      // 获取互斥角色待审批列表
      this.$http
        .post('/sum/sumRoleMutexAprv/selectPage', this.filters)
        .then(res => {
          if (res.code === 20000) {
            this.tableGridData = res.data.records
            this.page.total = res.data.total
          }
        })
        .catch(rej => {
          console.log(rej)
        })
    },
    // 批准
    approve(index, row) {
      this.$confirm('确认批准该申请吗?', '提示', {
        type: 'warning'
      }).then(() => {
        // 提交审核结果为通过
        let param = {
          id: row.id,
          action: row.action
        }
        this.$http
          .post('/sum/sumRoleMutexAprv/approve', param)
          .then(res => {
            if (res.code === 20000) {
              this.getRoleMutexAprvList()
            }
          })
          .catch(rej => {
            console.log(rej)
          })
      })
    },
    // 拒绝通过
    reject(index, row) {
      this.$confirm('确认批准该申请吗?', '提示', {
        type: 'warning'
      }).then(() => {
        // 提交审核结果为通过
        let param = {
          id: row.id,
          action: row.action
        }
        this.$http
          .post('/sum/sumRoleMutexAprv/reject', param)
          .then(res => {
            if (res.code === 20000) {
              this.getRoleMutexAprvList()
            }
          })
          .catch(rej => {
            console.log(rej)
          })
      })
    }
  }
}
</script>

<style lang="css">
</style>
